module.exports = __webpack_public_path__ + "img/dynamicmaschines_preview.b1659ef6.jpg";